<template>
    <div class="pageview-lp"></div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    methods: {
    },
    mounted() {
        document.title = "修芙缇会员中心";
        window.location.href = `http://qem.ink/${this.$route.query.code}`;

    },
}
</script>

<style lang="less" scoped>
.pageview-lp {
    box-sizing: border-box;
    width: 100%;
    height: 100vh;

}
</style>
